import React, {useState} from 'react';
import DocumentStepOne from './DocumentSteps/DocumentStepOne';
import DocumentStepTwo from './DocumentSteps/DocumentStepTwo/DocumentStepTwo';
import DocumentStepThree from './DocumentSteps/DocumentStepThree';
const DocumentForm = ({ setActiveStep, activeStep, t, 
  ExtensionLimitDetailsEndpoint,
  ExtraUserDetailsEndpoint,
  IsMockExtraUserDetailsEndpoint,
  GenerateOTPEndpoint,
  IsMockGenerateOTPEndpoint,
  VerifyOTPEndpoint,
  IsMockVerifyOTPEndpoint,
  DocumentSubmissionEndpoint,
  limitationNumber,
limitationMessage,
timeoutErrorMessage,
verificationCodeExpiredErrorMessage,
timeout,
otpVerificationCode,
otpDidNotReceiveText,
otpSendNewCodeText

}) => {
  const [extensionLimitDetails, setExtensionLimitDetails] = useState();
  const [extraUserData,setExtraUserData] = useState();
  const [generateOTPResponse,setGenerateOTPResponse] = useState();
  const [filesData, setFilesData] = useState({});
  const [verifyOTPResponse, setVerifyOTPResponse] = useState();
  const [filesizeErrorMessage, setFilesizeErrorMessage] = useState('');

  const renderStep = () => {
    switch (activeStep) {
      case 1:
        return <DocumentStepOne setActiveStep={setActiveStep} t={t} 
         filesizeErrorMessage={filesizeErrorMessage}
            setFilesizeErrorMessage={setFilesizeErrorMessage}
        ExtensionLimitDetailsEndpoint = {ExtensionLimitDetailsEndpoint}
        ExtraUserDetailsEndpoint = {ExtraUserDetailsEndpoint}
        IsMockExtraUserDetailsEndpoint = {IsMockExtraUserDetailsEndpoint}
        GenerateOTPEndpoint = {GenerateOTPEndpoint}
        IsMockGenerateOTPEndpoint = {IsMockGenerateOTPEndpoint}
        extensionLimitDetails = {extensionLimitDetails}
        setExtensionLimitDetails = {setExtensionLimitDetails}
        extraUserData = {extraUserData}
        setExtraUserData = {setExtraUserData}
        generateOTPResponse = {generateOTPResponse}
        setGenerateOTPResponse = {setGenerateOTPResponse}
        filesData = {filesData}
        setFilesData = {setFilesData}

        />;
      case 2:
        return <DocumentStepThree setActiveStep={setActiveStep} t={t} 
         filesizeErrorMessage={filesizeErrorMessage}
            setFilesizeErrorMessage={setFilesizeErrorMessage}
        VerifyOTPEndpoint = {VerifyOTPEndpoint}
        IsMockVerifyOTPEndpoint = {IsMockVerifyOTPEndpoint}
        extraUserData = {extraUserData}
        verifyOTPResponse = {verifyOTPResponse}
        setVerifyOTPResponse = {setVerifyOTPResponse}
        generateOTPResponse = {generateOTPResponse}
        setGenerateOTPResponse = {setGenerateOTPResponse}
        DocumentSubmissionEndpoint = {DocumentSubmissionEndpoint}
        GenerateOTPEndpoint = {GenerateOTPEndpoint}
        IsMockGenerateOTPEndpoint = {IsMockGenerateOTPEndpoint}
        filesData = {filesData}
        limitationNumber = {limitationNumber}
        limitationMessage = {limitationMessage}
        timeoutErrorMessage = {timeoutErrorMessage}
        verificationCodeExpiredErrorMessage = {verificationCodeExpiredErrorMessage}
        timeout = {timeout}
        otpVerificationCode = {otpVerificationCode}
        otpDidNotReceiveText = {otpDidNotReceiveText}
        otpSendNewCodeText = {otpSendNewCodeText}
        />;
      case 3:
        return <DocumentStepTwo setActiveStep={setActiveStep}/>;
      default:
        return null;
    }
  };
  return <div className="form">{renderStep()}</div>;
};

export default DocumentForm;
